import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';
import { GenericDecimalInput } from '../../components';


const PaymentWithinCountInputs: InputWithoutSource = ({ input }) => (
    <GenericDecimalInput label={input.name} input={input} precision={0} />
);

PaymentWithinCountInputs.meta = {
    inputType: InputModel.name
};

export default observer(PaymentWithinCountInputs);
